// extracted by mini-css-extract-plugin
module.exports = {"committeeContainer":"CommitteesItem_committeeContainer__-zPg6","memberGrid":"CommitteesItem_memberGrid__1z5rE"};